import { render, staticRenderFns } from "./FilterGroupList.vue?vue&type=template&id=1f1238df&"
import script from "./FilterGroupList.vue?vue&type=script&lang=js&"
export * from "./FilterGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports